









import { Component, Vue } from 'vue-property-decorator'
import ServiceWorkerUpdatePopup from '@/pwa/components/ServiceWorkerUpdatePopup.vue'

@Component({
  name: 'App',
  components: {
    ServiceWorkerUpdatePopup
  }
})
export default class extends Vue {
  created() {
    const darkModeStorageSetting = localStorage.getItem('darkMode')
    if (darkModeStorageSetting != null && darkModeStorageSetting == 'true') {
      this.$vuetify.theme.dark = true
    }
    this.$store.dispatch('loadNotifications')
    const connection = new WebSocket(`${process.env.VUE_APP_WS}`)
    connection.onmessage = event => {
      // Vue data binding means you don't need any extra work to
      // update your UI. Just set the `time` and Vue will automatically
      // update the `<h2>`.
      console.log(event.data)
    }
    // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
    // @ts-ignore
    // this.$vuetify.theme.dark = true
    // checks to see if auth jwt token is valid or has expired, if it gets back 401 error log out
    // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
    // @ts-ignore
    // this.$http.interceptors.response.use(
    //   (response) => {
    //     return response
    //   },
    //   (error) => {
    //     if (error.response.status === 401) {
    //       if (this.$store.getters.authorized) {
    //         this.$store.dispatch('refreshtoken')
    //       } else {
    //         return Promise.reject(error)
    //       }
    //     } else {
    //       return Promise.reject(error)
    //     }
    //   }
    // )
  }
}
